import {Box, Grid, Typography} from "@mui/material";

export const HomeTextBlock = ({section, direction}) => {

    return (
        <Box sx={{p:0.5 , border:'1px solid #eaeaea', borderRadius:'5px', marginBottom:'5%'}}>
            <Grid container direction={{xs:'column', md:direction}} spacing={{xs:1, md:4}} alignItems={'center'} justifyContent={'center'}>
                {section.image && <Grid item xs={12} md={4} sx={{flexGrow: 1, display:'flex'}}>
                    <img style={{width: '100%', objectFit:'cover', height:'100%'}}
                         src={section.image}/>
                </Grid>}
                <Grid item xs={12} md={8} >
                    <Box sx={{py:0.5, borderLeft:'3px solid #d1112c'}}>
                        <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} textTransform={'uppercase'} style={{marginLeft:'1%'}}>
                            {section.title}
                        </Typography>
                        <Typography fontFamily={'Arial'} variant={'h6'} color={'#243773'} fontWeight={'normal'} textTransform={'none'} style={{marginLeft:'1%'}}>
                            {section.subtitle}
                        </Typography>
                    </Box>
                    <Typography variant={'body1'} fontWeight={'normal'} fontFamily={'Arial'} mt={2}>
                        {section.description}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}